module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiByp8kv8JHgFVrLDz8Z1JlFd2JQEl8qw.f9924532.woff2";